import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const PAYVANTAGE_FALLBACK = "https://www.payvantage.com/apply";

export async function getPayvantageUrl() {
  try {
    const { data } = await api.get("/config");
    return data.payvantage_url || PAYVANTAGE_FALLBACK;
  } catch {
    return PAYVANTAGE_FALLBACK;
  }
}
